import React from 'react';
import Navbar from './components/Navbar/Navbar.jsx';
import './App.scss';

function App() {
  return (
    <div className="App">
      <Navbar />
    </div>
  );
}

export default App;
